import { ViteSSG } from 'vite-ssg';

import App from './App.vue';

import { registerPlugins } from '@/shared/plugins';
import { routes } from '@/shared/plugins/router';

export const createApp = ViteSSG(App, { routes }, registerPlugins, {
    hydration: true,
});
